// @ts-nocheck
export function isCookieExists(cookiesList: Object, name: string){ 
    return Object.values(cookiesList).includes(name)
}

export function setExpirationDays(daysAmount: number) {
    let daysFromToday = new Date();
    daysFromToday.setDate(daysFromToday.getDate() + daysAmount);

    return daysFromToday;
}

export function getCookie(name: string){
    return document.cookie.split(';').some(function(c) {
        return c.trim().startsWith(name + '=')
    })
}

/**
 * Attempts to delete a cookie by name using common path and domain variations for compatibility.
 * @param name - The name of the cookie to delete.
 * @param path - Optional path for the cookie.
 * @param domain - Optional domain for the cookie.
 */
function attemptDeleteCookieVariants(name: string, path?: string, domain?: string): void {
    const cookieDomain: string = domain || window.location.hostname
    const cookiePath: string = path || '/'
    // Delete the cookie with the provided path and domain
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + cookiePath + '; domain=' + cookieDomain + ';'
    // Delete the cookie with a trailing slash in the path
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + (path ? path + '/' : '/') + '; domain=' + cookieDomain + ';'
    // Delete the cookie with a leading slash in the path
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + ('/' + (path || '')) + '; domain=' + cookieDomain + ';'
    // Delete the cookie with both leading and trailing slashes in the path
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + ('/' + (path || '') + '/') + '; domain=' + cookieDomain + ';'
}

/**
 * Deletes a cookie and ensures the operation is complete before proceeding.
 * @param name - The name of the cookie to delete.
 * @param path - Optional path for the cookie.
 * @param domain - Optional domain for the cookie.
 */
export async function deleteCookie(name: string, path?: string, domain?: string): Promise<void> {
    if (getCookie(name)) {
        attemptDeleteCookieVariants(name, path, domain)
        await ensureCookieDeleted(name)
    }
}

export function getCookies (){
    let pairs = document.cookie.split(";");
    let cookies = {};
    for (const element of pairs){
      let pair = element.split("=");
      cookies[(pair[0]+"").trim()] = pair.slice(1).join('=');
    }
    return cookies;
}

/**
 * Removes cookies matching specific patterns from the provided cookies list.
 * @param cookiesList - The list of cookies to check for removal.
 */
export function cleanUp(cookiesList: Record<string, string>): void {
    const cookieNames: string[] = Object.keys(cookiesList)
    /**
     * Determines if a cookie name matches any of the patterns for deletion.
     * @param name - The cookie name to check.
     * @returns True if the cookie should be deleted, false otherwise.
     */
    function shouldDeleteCookie(name: string): boolean {
        if (name.match(/.*Adobe/gi)) {
            return true
        }
        if (name.match(/s_.*/gi)) {
            return true
        }
        if (name.match(/QuantumMetric/gi)) {
            return true
        }
        if (name.match(/.*CAPTCHA/gi)) {
            return true
        }
        if (name.match(/(AEC|NID|DV|OTZ|1P_JAR)/gi)) {
            return true
        }
        if (name.match(/utag_.*/gi)) {
            return true
        }
        if (name.match(/s_pers/gi)) {
            return true
        }
        if (name.match(/s_sess/gi)) {
            return true
        }
        return false
    }
    const cookiesToDelete: string[] = []
    for (const name of cookieNames) {
        if (shouldDeleteCookie(name)) {
            cookiesToDelete.push(name)
        }
    }
    for (const name of cookiesToDelete) {
        deleteCookie(name)
    }
}

/**
 * Ensures the cookie is deleted by polling until it is removed or a timeout is reached.
 * @param name - The name of the cookie to check.
 * @returns Promise that resolves when the cookie is deleted or rejects on timeout.
 */
async function ensureCookieDeleted(name: string): Promise<void> {
    const TIMEOUT_MS: number = 1000
    const INTERVAL_MS: number = 50
    let elapsed: number = 0
    while (getCookie(name)) {
        await new Promise(function(resolve) { setTimeout(resolve, INTERVAL_MS) })
        elapsed = elapsed + INTERVAL_MS
    }
}